/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The high-level unit activation state.
 */
export enum SystemdActiveStateType {
  SystemdActiveStateActive = 'active',
  SystemdActiveStateReloading = 'reloading',
  SystemdActiveStateInactive = 'inactive',
  SystemdActiveStateFailed = 'failed',
  SystemdActiveStateActivating = 'activating',
  SystemdActiveStateDeactivating = 'deactivating',
  SystemdActiveStateMaintenance = 'maintenance',
  SystemdActiveStateRefreshing = 'refreshing',
  SystemdActiveStateUnknown = 'unknown',
}
